export const GET_NOTIFICATION_LIST_SUCCESS = 'GET_NOTIFICATION_LIST_SUCCESS';
export const getNotificationListSuccess = notifications => ({
  type: GET_NOTIFICATION_LIST_SUCCESS,
  payload: {
    notifications,
  },
});

export const GET_FAMILY_LIST_SUCCESS = 'GET_FAMILY_LIST_SUCCESS';
export const getFamilyListSuccess = families => ({
  type: GET_FAMILY_LIST_SUCCESS,
  payload: {
    families,
  },
});

export const REMOVE_NOTIFICATION_ITEM_SUCCESS = 'REMOVE_NOTIFICATION_ITEM_SUCCESS';
export const removeNotificationItemSuccess = notificationID => ({
  type: REMOVE_NOTIFICATION_ITEM_SUCCESS,
  payload: {
    notificationID,
  },
});
